import { CallListProfile } from "../CallListProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCallListProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: CallListProfile;
    panel1: Panel;
    panel2: Panel;
    sourceCallListProfile: DataSource;
}
